var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePwdSelected(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77702 11.5775H12.027V6.66417C12.027 6.46958 11.9885 6.27692 11.9138 6.09726C11.8391 5.91761 11.7295 5.75451 11.5915 5.61734C11.4535 5.48018 11.2897 5.37166 11.1096 5.29803C10.9295 5.22441 10.7366 5.18713 10.542 5.18833H10.1937V4.19833C10.1937 3.10432 9.75909 2.05511 8.9855 1.28152C8.21191 0.507931 7.1627 0.0733337 6.06868 0.0733337C4.97467 0.0733337 3.92546 0.507931 3.15187 1.28152C2.37828 2.05511 1.94368 3.10432 1.94368 4.19833V5.18833H1.60452C1.4095 5.18713 1.21616 5.22434 1.03553 5.29786C0.8549 5.37137 0.690519 5.47975 0.551772 5.61679C0.413025 5.75383 0.30263 5.91687 0.226891 6.09658C0.151152 6.27629 0.111552 6.46915 0.110352 6.66417V13.3008C0.111633 13.6748 0.253933 14.0344 0.508829 14.308C0.763724 14.5816 1.11245 14.749 1.48535 14.7767V13.86C1.48535 13.5595 1.54469 13.2619 1.65997 12.9844C1.77525 12.7069 1.9442 12.4548 2.15712 12.2428C2.37004 12.0307 2.62274 11.8628 2.90073 11.7486C3.17871 11.6344 3.47651 11.5763 3.77702 11.5775ZM3.77702 4.24417C3.77702 3.63638 4.01846 3.05349 4.44823 2.62371C4.878 2.19394 5.4609 1.9525 6.06868 1.9525C6.67647 1.9525 7.25937 2.19394 7.68914 2.62371C8.11891 3.05349 8.36035 3.63638 8.36035 4.24417V5.18833H3.77702V4.24417Z",
    fill: "#03045E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95378 13.18H18.4746C18.4746 13.18 19.3288 13.18 19.3288 14.0342V19.1592C19.3288 19.1592 19.3288 20.0133 18.4746 20.0133H3.95378C3.95378 20.0133 3.09961 20.0133 3.09961 19.1592V14.0342C3.09961 14.0342 3.09961 13.18 3.95378 13.18Z",
    stroke: "#03045E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.3154L8.0625 17.8779",
    stroke: "#03045E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 15.3154L5.5 17.8779",
    stroke: "#03045E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1973 15.3154L12.7598 17.8779",
    stroke: "#03045E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7598 15.3154L10.1973 17.8779",
    stroke: "#03045E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2705 17.7904H17.2705",
    stroke: "#03045E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21387 7.21355V9.34896",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21354 7C6.25578 7 6.29706 7.01252 6.33218 7.03599C6.3673 7.05945 6.39467 7.0928 6.41083 7.13182C6.42699 7.17084 6.43122 7.21378 6.42298 7.2552C6.41474 7.29663 6.3944 7.33467 6.36454 7.36454C6.33467 7.3944 6.29662 7.41474 6.2552 7.42298C6.21378 7.43122 6.17084 7.42699 6.13182 7.41083C6.0928 7.39467 6.05945 7.3673 6.03599 7.33218C6.01252 7.29706 6 7.25578 6 7.21354C6 7.15691 6.0225 7.10259 6.06254 7.06254C6.10259 7.0225 6.15691 7 6.21354 7Z",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePwdSelected);
export default __webpack_public_path__ + "static/media/ChangePwdSelected.625a0f33b70dfdd7575767f6c05c276f.svg";
export { ForwardRef as ReactComponent };